var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import Logo from '../../Elements/Logo/Logo';
const NavBarStyle = styled.div `
  color: white;
  position: relative;
  padding: ${props => props.theme.paddingsMargins.themeMenuPadding};
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  display: flex;
  z-index: 99;
  align-items: center;
  justify-content: space-between;
  height: 2.6rem;
  box-shadow: ${props => props.theme.boxes.navShadow};
  margin-bottom: 1.3rem;
  background-color: ${(props) => props.secondary ? props.theme.colors.secondaryColor : props.theme.colors.mainColor};
`;
const LogoContainer = styled.div `
  justify-self: start;
  transform: ${props => props.isLogoClicked ? 'scale(0.9)' : 'scale(1)'};
  cursor: pointer;
  grid-column: 1;
  display: inline-block;
  margin-left: ${props => props.theme.spacings.halfSpacing};
  background: transparent;
  user-select: none;
`;
const NavContainer = styled.nav `
  grid-column: 2;
  justify-self: end;
`;
const NavBar = (_a) => {
    var { secondary = false, logo, logoEvent = () => { }, logoHeight = '2', children } = _a, props = __rest(_a, ["secondary", "logo", "logoEvent", "logoHeight", "children"]);
    const theme = useTheme();
    const [isLogoClicked, setIsLogoClicked] = useState(false);
    const clickOnLogo = (e) => {
        if (logoEvent)
            logoEvent(e);
    };
    return (_jsxs(NavBarStyle, Object.assign({ secondary: secondary }, props, { children: [(logo && !theme.logo) &&
                _jsx(LogoContainer, Object.assign({ onClick: clickOnLogo, isLogoClicked: isLogoClicked, onMouseDown: () => setIsLogoClicked(true), onMouseUp: () => setIsLogoClicked(false) }, { children: _jsx(Logo, { logo: logo, height: logoHeight, noMargin: true, display: "block" }) })), theme.logo &&
                _jsx(LogoContainer, Object.assign({ onClick: clickOnLogo, isLogoClicked: isLogoClicked, onMouseDown: () => setIsLogoClicked(true), onMouseUp: () => setIsLogoClicked(false) }, { children: _jsx("img", { src: theme.logo, style: { width: 'auto', height: '46px', marginTop: '5px' } }) })), _jsx(NavContainer, { children: children })] })));
};
export default NavBar;
